import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.scss';

import Capa from './app/capa/page';
import CapaV2 from './app/capa2/page';
import Eventos from './app/eventos/page';
import NotFound from './app/404/page';
import AcessoIndisponivel from './app/acessoIndisponivel/page';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<CapaV2 />} />
          <Route path="/capa-old" element={<Capa />} />
          <Route path="/capa2" element={<CapaV2 />} />
          <Route path="/Eventos" element={<Eventos />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/acesso-indisponivel" element={<AcessoIndisponivel />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;